export default {
  'dropzone.importSizeError': '<%=file%> exceeded <%=size%> MB limit.',
  'dropzone.cannotBeUploaded': 'File cannot be uploaded',
  'dropzone.fileFailedAction': 'Retry',
  'dropzone.fileSuccessAction': 'Delete'
};
